import { Manager } from 'socket.io-client'

import { projectName } from '@/utils'

import { getSocketURL } from './request/runtime'

let socket = null

const buildManager = () => {
  const token = window.localStorage.getItem(`${projectName}:token`)
  if (!token) {
    return null
  }

  const url = getSocketURL()

  return new Manager(url, {
    protocols: [ 'websocket' ],
    transports: [ 'websocket' ],
    reconnection: false,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    reconnectionAttempts: 5,
    autoConnect: false,
    query: { token }
  })
}

export const createSocket = () => {
  socket?.close()

  const manager = buildManager()
  socket = manager?.socket('/')
  socket?.connect()

  return socket
}

export const getSocket = () => {
  if (socket) {
    return socket
  }

  return createSocket()
}

export const disconnectSocket = () => {
  getSocket()?.disconnect()
}
